import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Table from "components/accountant-table/accountant-table.component";

import { AuthContext } from "src/contexts/auth.context";
import { ClientsContext } from "src/contexts/clients.context";

import { COLORS } from "utils/lists.utils";

import "./notifications.style.scss";

const DATA = [
	{
		companyType: 0,
		name: "Kate",
		surname: "Bush",
		username: "_KateBush",
		vatNumber: "UK 4444444444",
		jobTitle: "Singer",
		email: "katebush@gmail.com",
		phone: "+44 7700 900651",
		country: "United Kingdom",
		city: "London",
		address: "Upside Hill Street 99",
		zipCode: "1978",
		id: "123",
		createdAt: "September 19, 2003",
		color: COLORS[1],
		subscription: 0,
		archivePeriod: 1,
		safeLockingPeriod: 2,
		liveChat: 0,
		mobile: 0,
		filler: { done: 100, message: 20, invoices: 13 },
	},
	{
		companyType: 1,
		company: {
			name: "Spotify",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[2],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010929",
		filler: { done: 100, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane",
				surname: "Doe",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole",
				surname: "Kidman",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl",
				surname: "Streep",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano",
				surname: "David",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Nicole",
				surname: "Kidman",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
	{
		companyType: 1,
		company: {
			name: "Dell Technologies",
			img: "",
			vatNumber: "BE 4444444444",
			createdAt: "September 19, 2003",
			color: COLORS[4],
			type: "Limited",
			clientType: 0,
			email: "placeholder@placeholder.com",
			specialities: "Musicians",
			website: "http://www.spotify.com",
			address: "Stockholm, Sweden",
			subscription: 0,
			archivePeriod: 1,
			safeLockingPeriod: 2,
			liveChat: 0,
			mobile: 0,
		},
		id: "010950",
		filler: { done: 10, message: 20, invoices: 13 },
		employees: [
			{
				id: 0,
				name: "Jane Doe",
				surname: "",
				jobTitle: "Chief Financial Officier",
				email: "jane.doe@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 0,
			},
			{
				id: 0,
				name: "Nicole Kidman",
				surname: "",
				jobTitle: "Sales Manager",
				email: "nicole.kidman@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Meryl Streep",
				surname: "",
				jobTitle: "Sales Intern",
				email: "meryl.streep@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
			{
				id: 0,
				name: "Damiano David",
				surname: "",
				jobTitle: "Finance Intern",
				email: "damiano.david@spotify.com",
				phone: "+01 123 456 78 99",
				userType: 1,
			},
		],
	},
];

const Notifications = () => {
	const {
		user: { name },
	} = useContext(AuthContext);
	const { clients } = useContext(ClientsContext);
	const navigate = useNavigate();

	const [data, setData] = useState([]);

	useEffect(() => {
		setData(DATA);
	}, []);

	const handleClick = (companyName) => {
		const index = clients.findIndex((client) => {
			if (client.companyType === 0) {
				return companyName === client.name + " " + client.surname;
			}
			return companyName === client?.company.name ?? "";
		});

		navigate("/clients", { replace: true, state: { initialIndex: index } });
	};

	const handleDelete = (index) => {
		setData((prevData) => {
			const tempData = [...prevData];
			tempData.splice(index, 1);
			return tempData;
		});
	};

	return (
		<div className="notifications-container route-container">
			<p className="size700 w600 margin-l--bottom">Good Morning {name},</p>
			<p className="size600 w500 margin-s--bottom with-line">Notifications</p>
			<Table data={data} onRowClick={handleClick} onDelete={handleDelete} />
		</div>
	);
};
export default Notifications;
